import { render, staticRenderFns } from "./FollowFansDialog.vue?vue&type=template&id=389c1236&scoped=true&"
import script from "./FollowFansDialog.vue?vue&type=script&lang=js&"
export * from "./FollowFansDialog.vue?vue&type=script&lang=js&"
import style0 from "./FollowFansDialog.vue?vue&type=style&index=0&id=389c1236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c1236",
  null
  
)

export default component.exports